<div class="product-coupon-vip-template-root">
<div>
  <div class="title" [matTooltip]="(title.length > 30) ? (title) : ''"  
    matTooltipClass="name-tooltip">
    <app-header isBig title>{{ title }}</app-header>
  </div>
  <div class="instructions">
    <app-paragraph description bold
      >{{ label1 }} <br /><br />
      {{ label2 }}
    </app-paragraph>
  </div>
</div>
  <div class="coupon">
    <div #couponCard>
      <mat-spinner
      *ngIf="loading"
      class="loading"
      diameter="50"
      ></mat-spinner>
      <app-coupon-card-vip
        *ngIf="!loading"
        coupon
        [businessName]="businessName"
        [couponCode]="coupon.code!"
        [startingDate]="coupon.startingDate!"
        [expirationDate]="coupon.expirationDate!"
        [active]="coupon.active!"
        [vipLevel]="coupon.vipName!"
        [familyName]="coupon.businessLevel.familyName!"
        [resellerName]="coupon.resellerName!"
        [discountValue]="coupon.discount!"
        [business]="coupon.business"
        [printers]="coupon.printers"
        [businessImgBase64]="businessImgBase64"
        [countryName]="businessCountry"
        [configSeriesDisclaimer]="getPromoTextByLanguage(coupon.vipConfigSeries)"
      ></app-coupon-card-vip>
    </div>
  </div>
  <div #buttons class="button-area">
    <div
      class="clickable-area"
      (click)="copy()"
      [title]="translatedStrings['copy-coupon-code']"
      id="copy-coupon-code"
    >
      <button mat-mini-fab color="">
        <mat-icon class="icon"> content_copy </mat-icon>
        <div
          #tooltip="matTooltip"
          matTooltip="{{ this.translatedStrings.codeCopied }}"
        ></div>
      </button>
      <app-label>{{ translatedStrings['copy-coupon-code'] }}</app-label>
    </div>
    <div (click)="downloadCoupon()" class="clickable-area" [title]="translatedStrings['download-coupon']" id="download-coupon">
      <button mat-mini-fab color="">
        <mat-icon class="icon"> download </mat-icon>
      </button>
      <app-label>{{ translatedStrings['download-coupon'] }}</app-label>
    </div>
    <div (click)="printCoupon()" class="clickable-area" [title]="translatedStrings.print" id="print-coupon">
      <button mat-mini-fab color="">
        <mat-icon class="icon"> print </mat-icon>
      </button>
      <app-label>{{ translatedStrings.print }}</app-label>
    </div>
  </div>
</div>
  
